// src/api/adminCampaignsApi.ts
// Solicitudes de campañas de CORREO pendientes de aprobar (super_admin / plataforma).
// Gobierno "solicitud → revisión → aprobación": el dueño solicita, la plataforma aprueba;
// sin aprobar el worker NO envía. Backend: routes/admin.js (requirePlatform).
import { baseApi } from './baseClient';

export interface PendingEmailCampaign {
  id: number;
  tenant_id: number;
  tenant: string;
  name: string;
  email_subject: string | null;
  status: string;
  total_queued: number;
  scheduled_at: string | null;
}

export const adminCampaignsApi = {
  async listPendingEmail(): Promise<PendingEmailCampaign[]> {
    const r = await baseApi.get<{ pending: PendingEmailCampaign[] }>('/admin/campaigns/email-pending');
    return r.pending || [];
  },
  approve(id: number): Promise<{ ok: boolean; status?: string }> {
    return baseApi.post(`/admin/campaigns/${id}/approve`);
  },
  unapprove(id: number): Promise<{ ok: boolean }> {
    return baseApi.post(`/admin/campaigns/${id}/unapprove`);
  },
};

export default adminCampaignsApi;
